import { useDisclosure } from '@chakra-ui/react'

export const useModalPass = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()

  return { isOpen, onOpen, onClose }
}
